// client/src/store/authActions.js

/**
 * Root-level action that wipes every auth slice at once.
 *
 * Each portal used to clear only its own slice on logout, so signing out of the
 * teacher portal left the school slice populated - and /dashboard, which picks a
 * portal by looking for whichever slice is non-empty, would then show the admin
 * dashboard to a logged-out teacher. One reset for all roles avoids that.
 */
export const RESET_ALL_AUTH = 'auth/resetAll';

export const resetAllAuth = () => ({ type: RESET_ALL_AUTH });
